<template>
    <form method="POST" action="/demo">
        <csrf/>

        <div class="demo">
            <div class="demo__heading">
                <span class="demo__title">
                    {{ trans('demo.title') }}
                </span>
            </div>

            <div class="demo__description" v-html="trans('demo.description')"></div>

            <div class="demo__form">
                <div class="form-section">
                    <div class="form-section__heading">
                        {{ trans('demo.personal_data') }}
                    </div>

                    <div class="form-section__body">
                        <form-input :label="trans('demo.company')" name="company"></form-input>
                        <form-input :label="trans('demo.position')" name="position"></form-input>
                        <form-input :label="trans('demo.firstname')" name="firstname"></form-input>
                        <form-input :label="trans('demo.lastname')" name="lastname"></form-input>
                        <form-input :label="trans('demo.email')" name="email"></form-input>
                        <form-input :label="trans('demo.phone')" name="phone"></form-input>
                    </div>

                    <div class="form-section__checkboxes">
                        <checkbox class="mb-2" name="terms_of_use" v-model="termsOfUse"><span v-html="trans('orders.summary.terms_of_use')"></span></checkbox>
                    </div>
                </div>
            </div>
        </div>

        <page-control :label="trans('page-control.submit_demo_form')" button centered margin-bottom></page-control>

        <page-control :label="trans('page-control.back_to_products')" link href="/produkte" margin-bottom></page-control>
    </form>
</template>

<script>
export default {
    data() {
        return {
            termsOfUse: false,
        };
    },
}
</script>
